import { render, staticRenderFns } from "./AddMatrix.vue?vue&type=template&id=fca2af28&"
import script from "./AddMatrix.vue?vue&type=script&lang=js&"
export * from "./AddMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports